
var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/wilddog/~/engine.io-client/~/indexof/index.js
 ** module id = 431
 ** module chunks = 1
 **/